import { createModule } from '@evyweb/ioctopus';

import { definitionService } from '../../infrastructure/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates and configures the definition module.
 *
 * @returns The configured definition module.
 */
export function createDefinitionModule(): ReturnType<typeof createModule> {
  const definitionModule = createModule();

  // Services
  definitionModule.bind(diSymbolMap.IDefinitionService).toHigherOrderFunction(definitionService);

  return definitionModule;
}
